import React from "react";
import IfscCodeMapper from "../IfscLogoMapper";

// Suggestions of props for component while using the component -------------------------------------
/**
 * @typedef {("small" | "big")} LogoVariant
 * @typedef {("pill" | "normal")} type
 *
 * @param {Object} props
 * @param {string} props.ifsc - IFSC code used to determine and map the bank logo.
 * @param {LogoVariant} props.variant - Logo size variant; choose between "small" or "big".
 * @param {type} props.type - Logo shape type; choose between "pill" or "normal".
 * @returns {JSX.Element} Renders a bank logo image mapped via IFSC code.
 */

const CommonBankLogo = ({ ifsc, variant, type }) => {
  const variantClasses = {
    small:
      "Qsmd:w-banklogo-width-sm Qsmd:h-banklogo-height-sm w-banklogo-width-mobile h-banklogo-height-mobile flex-shrink-0",
    big: "Qsmd:w-banklogo-width-lg Qsmd:h-banklogo-height-lg w-banklogo-width-mobile h-banklogo-height-mobile flex-shrink-0",
  };
  const typeClasses = {
    pill: "py-padding-button-s px-padding-sm bg-text-primary rounded-border-radius-l",
    normal: "",
  };

  const logoSizeClass = variantClasses[variant];
  const typeClass = typeClasses[type];

  const content = (
    <div className={logoSizeClass}>
      <IfscCodeMapper ifscCode={ifsc} />
    </div>
  );

  return typeClass ? <div className={typeClass}>{content}</div> : content;
};

export default CommonBankLogo;
